<template lang="pug">
include /mixins
+b.ticket-form-wrapper
  //- +e.title-wrap(v-if='appealType')
  //-   +e.title.H1 {{ appealType.props.title }}
  //-   +e.description.P {{ appealType.props.description }}
  +e.circle--large.IMG(src='/static/img/redesign/ticket_circle_2.svg')

  +e.form
    ticket-form(
      :type='type'
      :appeal='appealType'
    )
    +e.circle--mini.IMG(src='/static/img/redesign/ticket_circle_1.svg')
</template>

<script>

import {
  ADD_POSITIVE_TICKET_NAME,
  ADD_NEGATIVE_TICKET_NAME,
} from '@app/Staff/Ticket/routes'
import {
  getTypeOfAppeals,
} from '@api/ticket.service'
import TicketForm from '@app/TicketManagement/Form'

const POSITIVE = 1
const NEGATIVE = 2

export default {
  name: 'TicketAdd',
  components: {
    TicketForm,
  },
  data() {
    return {
      types: {
        [ADD_POSITIVE_TICKET_NAME]: 1,
        [ADD_NEGATIVE_TICKET_NAME]: 2,
      },
      titles: {
        [POSITIVE]: {
          title: 'Положительный отзыв',
          description: 'Сообщите о своем',
        },
        [NEGATIVE]: {
          title: 'Создать обращение',
          description: 'Создание обращения в службу поддержки',
        },
      },
      appeals: [],
    }
  },
  computed: {
    type() {
      return this.types[this.$route.name]
    },
    appealType() {
      return this.appeals.find(item => item.id === this.type)
    },
  },
  mounted() {
    this.getTypeOfAppeals()
  },
  methods: {
    async getTypeOfAppeals() {
      const { data: { items } } = (await getTypeOfAppeals.execute())
      this.appeals = items
    },
  },
}
</script>
